import { IRootState } from '@/store/type'
import { Module } from 'vuex'
import { ISystemState } from './types'
import {
  getPageListData,
  deletePageData,
  createPageData,
  editPageData
} from '@/service/main/system/system'
const systemModule: Module<ISystemState, IRootState> = {
  namespaced: true,
  state() {
    return {
      userList: [],
      departList: [],
      userCount: 0,
      departCount: 0,
      menuList: [],
      menuCount: 0,
      noticeList:[],
      noticeCount: 0,
      operatorList: [],
      operatorCount: 0,
      payList: [],
      payCount: 0,
      intentionList: [],
      intentionCount: 0
    }
  },
  mutations: {
    //用户列表
    changeUserList(state, userList: any[]) {
      state.userList = userList
    },
    changeUserCount(state, userCount: number) {
      state.userCount = userCount
    },
    // 发布信息列表
    changeDepartList(state, departList: any[]) {
      state.departList = departList
    },
    changeDepartCount(state, departCount: number) {
      state.departCount = departCount
    },
    //菜单列表
    changeMenuList(state, list: any[]) {
      state.menuList = list
    },
    changeMenuCount(state, count: number) {
      state.menuCount = count
    },
    changeNoticeList(state, list: any[]) {
      state.noticeList = list
    },
    changeNoticeCount(state, count: number) {
      state.noticeCount = count
    },
    changeOperatorList(state, list: any[]) {
      state.operatorList = list
    },
    changeOperatorCount(state, count: number) {
      state.operatorCount = count
    },
    changePayList(state, list: any[]) {
      state.payList = list
    },
    changePayCount(state, count: number) {
      state.payCount = count
    },
    changeIntentionList(state, list: any[]) {
      state.intentionList = list
    },
    changeIntentionCount(state, count: number) {
      state.intentionCount = count
    }
  },
  getters: {
    pageListData(state) {
      return (pageName: string) => {
        return (state as any)[`${pageName}List`]
        // switch (pageName) {
        //   case 'user':
        //     return state.usersList
        //   case 'role':
        //     return state.roleList
        // }
      }
    },
    pageListCount(state) {
      return (pageName: string) => {
        return (state as any)[`${pageName}Count`]
      }
    }
  },
  actions: {
    async getPageListAction({ commit }, payload) {
      // 1.获取pageUrl
      const pageName = payload.pageName
      const pageUrl = payload.pageUrl
      // 2.对页面发送请求
      const pageResult = await getPageListData(pageUrl, payload.queryInfo,payload.methods)
      // 3.将数据存储到state中
      let { rows,total } = pageResult?.data || pageResult
      console.log(rows,total)
      if(!rows&&!total){
        rows = pageResult.data
        total = pageResult.data.length
      }
      const changePageName =
        pageName.slice(0, 1).toUpperCase() + pageName.slice(1) //设置首字母大写
        console.log(`change${changePageName}List`)
      commit(`change${changePageName}List`, rows)
      commit(`change${changePageName}Count`, total)
    },
    async deletePageDataAction({ dispatch }, payload: any) {
      // 1.获取pageName和id
      // pageName -> /users
      // id -> /users/id
      const { pageName, id } = payload
      const pageUrl = `${pageName}/${id}`
      // 2.调用删除网络请求
      await deletePageData(pageUrl)
      // 3.重新请求最新的数据

      dispatch('getPageListAction', {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10
        }
      })
    },
    async createPageDataAction({ dispatch }, payload: any) {
      const { pageName, newData } = payload
      const pageUrl = `/${pageName}`
      await createPageData(pageUrl, newData)
      dispatch('getPageListAction', {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10
        }
      })
    },

    async editPageDataAction({ dispatch }, payload: any) {
      const { pageName, editData, id } = payload
      const pageUrl = `/${pageName}/${id}`
      await editPageData(pageUrl, editData)
      dispatch('getPageListAction', {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10
        }
      })
    }
  }
}
export default systemModule
